import React from 'react';
import { useTranslation } from 'react-i18next';

import scss from './NoBrand.module.scss';

function NoBrand() {
  const { t } = useTranslation('sonar');

  return (
    <div className={scss.noBrand}>
      <span>{t('clickOnBrand')}</span>
    </div>
  );
}

export default NoBrand;
